import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {TransitionService} from "@uirouter/angularjs";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {Debugger} from "debug";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Transition} from "@uirouter/core/lib/transition/transition";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {GruppeDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";
import {GruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {takeUntilAjs$destroy} from "felles/ng2/rxjsHjelpere";
import {GruppeModellDML} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {distinctUntilChangedDeep} from "felles-ng2/støttefunksjoner/observable";
import {Feilhåndteringsstrategi} from "felles-ng2/tjenester/datalager/datatjeneste";
import {HttpErrorResponse} from "@angular/common/http";
import {erResponsStatus4XX} from "felles-ng2/infrastruktur/http/httpResponskoder";

require('./gruppe.scss');
const debug: Debugger = require('debug')('GruppeKontroller');


export class GruppeKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wgGruppe', {
              bindings: {id: '<', aktivArkfane: '<', valgtMedlemId: '<', erRedigerMoetemal: '<'},
              controller: GruppeKontroller.forInjisering(),
              template: require('./gruppe.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.ui.$transitions,
            ng2RegNavn.GruppeDatatjenesteForAjs,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            IntroJsTjeneste.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            GruppeKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $transitions: TransitionService,
                private gruppeDatatjenesteForAjs: GruppeDatatjenesteForAjs,
                private webNavigasjon: WebNavigasjon,
                private kontekst: Kontekst,
                private introJs: IntroJsTjeneste,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog) {
    }

    id: string; //settes via bindings/$onChanges
    /** forespurt initiell arkfane */
    aktivArkfane: 'medlemmer' | 'planer' | 'aksjeeierbok' | 'statistikk' | 'konfigurasjon' | 'endringshendelser' | 'moetemal' | 'administrasjon' | 'sikkerhetsinnstillinger' | 'gruppeBrukerMal' = 'medlemmer';//settes via bindings/lyttTilNavigasjon
    valgtMedlemId: string = null; //settes via bindings/lyttTilNavigasjon
    erRedigerMoetemal = false; //settes via bindings/lyttTilNavigasjon

    gruppe: l.GruppeModell;
    gruppeNg2: GruppeModellDML;

    private tilAvregistrering: Function[] = [];

    navigasjonDeaktivert() {
        return this.webNavigasjon.navigasjonDeaktivert();
    }

    redigerMoetemal() {
        this.webNavigasjon.gåTilGruppeMøtemalRediger(this.gruppe.id);
    }

    vedMoetemalLagret() {
        this.navigerTilMoetemal();
    }

    vedMoetemalRedigerAvbrutt() {
        this.navigerTilMoetemal();
    }

    arkfaneAksjeeierbokTilgjengelig() {
        return this.gruppe?.aksjeeierbokId != null;
    }

    arkfaneGrupperBrukerMalTilgjengelig() {
        return this.gruppe?.gruppetype === l.Gruppetype.mal;
    }

    navigerTilMedlemmer() {
        this.webNavigasjon.navigasjonDeaktivert()
        this.webNavigasjon.gåTilGruppe(this.id);
    }

    navigerTilPlaner() {
        this.webNavigasjon.gåTilGruppePlaner(this.id);
    }

    navigerTilAksjeeierbok() {
        this.lastGruppe(this.id); //sørger for at ferske data blir lastet - ellers er feks ikke nye invitasjon og endr i roller synlige
        this.webNavigasjon.gåTilGruppeAksjeeierbok(this.id);
    }

    navigerTilStatistikk() {
        this.webNavigasjon.gåTilGruppeStatistikk(this.id);
    }

    navigerTilKonfigurasjon() {
        this.webNavigasjon.gåTilGruppeKonfigurasjon(this.id);
    }

    navigerTilEndringshendelser() {
        this.webNavigasjon.gåTilGruppeEndringshendelser(this.id);
    }

    navigerTilMoetemal() {
        this.webNavigasjon.gåTilGruppeMøtemal(this.id);
    }

    navigerTilAdministrasjon() {
        this.webNavigasjon.gåTilGruppeAdministrasjon(this.id);
    }

    navigerTilSikkerhetsinnstillinger() {
        this.webNavigasjon.gåTilGruppeSikkerhetsinnstillinger(this.id);
    }

    navigerTilGrupperBrukerMal() {
        this.webNavigasjon.gåTilGrupperBrukerMal(this.id);
    }

    aktivArkfaneMedlemmer() {
        return this.aktivArkfane === 'medlemmer';
    }

    aktivArkfanePlaner() {
        return this.aktivArkfane === 'planer';
    }

    aktivArkfaneAksjeeierbok() {
        return this.aktivArkfane === 'aksjeeierbok';
    }

    aktivArkfaneStatistikk() {
        return this.aktivArkfane === 'statistikk';
    }

    aktivArkfaneKonfigurasjon() {
        return this.aktivArkfane === 'konfigurasjon';
    }

    aktivArkfaneEndringshendelser() {
        return this.aktivArkfane === 'endringshendelser';
    }

    aktivArkfaneMoetemal() {
        return this.aktivArkfane === 'moetemal';
    }

    aktivArkfaneAdministrasjon() {
        return this.aktivArkfane === 'administrasjon';
    }

    aktivArkfaneSikkerhetsinnstillinger() {
        return this.aktivArkfane === 'sikkerhetsinnstillinger';
    }

    aktivArkfaneGrupperBrukerMal() {
        return this.aktivArkfane === 'gruppeBrukerMal';
    }

    $onInit(): void {
        debug('$onInit', this.id, this.aktivArkfane, this.valgtMedlemId);
        this.lyttTilNavigasjon();
    }

    $onChanges(endringer: IOnChangesObject): void {
        debug('$onChanges', endringer);
        dersomChangesInneholder(endringer, 'id', id => this.lastGruppe(id));
    }

    $onDestroy(): void {
        this.tilAvregistrering.forEach(avregistrering => avregistrering());
    }


    //hjelpemetoder

    private lastGruppe(gruppeId: string) {
        this.id = gruppeId;
        this.gruppeDatatjenesteForAjs.tjenestekallOmsluttetIAjsApplyAsync(this.$scope, gruppeDatatjeneste => {
            gruppeDatatjeneste.hent(this.id, Feilhåndteringsstrategi.propagerSomError)
              .pipe(
                //dersom vi unnlater denne vil dette føre til en rekursiv brønn om bruker står på feks medlemmer-siden da medlemmer-vis
                //vil trigge en ny lasting av gruppe for å hente medlemmer som vil lever denne her som igjen vil føre til at gruppeId-argumentet
                //til medlemmer-vis blir oppdatert og medlemmer hentes på nytt...
                distinctUntilChangedDeep(),
                takeUntilAjs$destroy(this.$scope))
              .subscribe({
                  next: gruppe => {
                      this.gruppeNg2 = gruppe;
                      this.gruppe = kopierFraNg2TilAjs(gruppe);
                      gruppeDatatjeneste.aktivGruppe = gruppe as GruppeModell;
                      this.initIntroJs();
                  },
                  error: respons => this.gruppeIkkeFunnet(respons)
              });
        });
    }

    private gruppeIkkeFunnet(respons: HttpErrorResponse) {
        if (erResponsStatus4XX(respons)){
            this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Forespurt gruppe eksisterer ikke'));
            this.webNavigasjon.gåTilGrupper();
            return;
        }
        this.meldingTilBruker.feilmelding(this.gettextCatalog.getString('Kunne ikke hente gruppe'));
    }

    private lyttTilNavigasjon() {
        this.tilAvregistrering.push(this.$transitions.onSuccess({}, (trans: Transition) => {
            debug("$transitions.onSuccess", trans, trans.paramsChanged(), trans.params())
            this.aktivArkfane = trans.params().aktivArkfane;
            this.valgtMedlemId = trans.params().medlemId;
            this.erRedigerMoetemal = trans.params().rediger;
        }));
    }

    private initIntroJs() {
        this.kontekst.erLastetFraServer().then(() => {
            if (!this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.gruppe.id)) {
                return;
            }

            this.introJs.visIntroForsinket(
              this.introJs.nyIntroduksjon('gruppe')
                .leggTilSteg(
                  1,
                  {
                      title: this.gettextCatalog.getString('Gruppemeny'),
                      intro: this.gettextCatalog.getString('I gruppemenyen kan du redigere infoen om gruppen, samt importere medlemmer fra fil, og hente rapport for møtedeltakelse.'),
                      element: '[data-tips-id="gruppe-meny"]',
                      position: 'bottom'
                  }
                )
                .leggTilSteg(
                  2,
                  {
                      title: this.gettextCatalog.getString('Planer'),
                      intro: this.gettextCatalog.getString('Oversikt over gruppens årsplaner.'),
                      element: '[data-tips-id="gruppe-tab-planer"]',
                      position: 'bottom'
                  }
                )
                .leggTilSteg(
                  3,
                  {
                      title: this.gettextCatalog.getString('Oppsett'),
                      intro: this.gettextCatalog.getString('Redigering av sakstyper, tema, roller og årshjulinnslag.'),
                      element: '[data-tips-id="gruppe-tab-konfigurasjon"]',
                      position: 'bottom'
                  }
                )
                .leggTilSteg(
                  4,
                  {
                      title: this.gettextCatalog.getString('Møtemal'),
                      intro: this.gettextCatalog.getString('Her kan du redigere malsaker, faste deltakere, og møtedetaljene som ligger i møtemalen.'),
                      element: '[data-tips-id="gruppe-tab-moetemal"]',
                      position: 'bottom'
                  }
                )
                .leggTilSteg(
                  5,
                  {
                      title: this.gettextCatalog.getString('Sikkerhet'),
                      intro: this.gettextCatalog.getString('Her kan du aktivere én eller flere innloggingsmetoder for gruppen. Vi anbefaler e-ID, men alt er bedre enn brukernavn og passord!'),
                      element: '[data-tips-id="gruppe-tab-sikkerhet"]',
                      position: 'bottom'
                  }
                )
                .leggTilSteg(
                  6,
                  {
                      title: this.gettextCatalog.getString('Invitere medlem'),
                      intro: this.gettextCatalog.getString('Nederst på siden kan du invitere nye medlemmer til gruppen. Det gjør du enten manuelt eller ved å importere fra regneark.'),
                      element: '[data-tips-id="inviter-medlem"]',
                      position: 'right'
                  }
                ),
              1000
            )
        });
    }
}
